<template>
  <CardBase class="animate-pulse">
    <div class="w-72 relative h-52 rounded border-2 border-shade-900 bg-shade-200 md:h-60"></div>

    <section class="flex h-40 flex-col items-center gap-2 p-4">
      <!-- Title -->
      <div class="h-4 w-3/4 rounded bg-shade-200"></div>

      <!-- Description lines -->
      <div class="h-3 w-full rounded bg-shade-200"></div>
      <div class="h-3 w-2/3 rounded bg-shade-200"></div>

      <!-- Persons -->
      <div class="mt-2 flex gap-2">
        <div v-for="i in 2" :key="i" class="h-4 w-16 rounded bg-shade-200" />
      </div>

      <!-- Date -->
      <div class="mt-2 h-3 w-20 rounded bg-shade-200"></div>

      <!-- Tags -->
      <div class="mt-2 flex flex-wrap gap-1">
        <div v-for="i in 3" :key="'tag-' + i" class="h-4 w-10 rounded bg-shade-200" />
      </div>
    </section>
  </CardBase>
</template>

<script setup lang="ts"></script>
